import { Controller } from '@hotwired/stimulus'

// Raw window.google Maps API for regions/show and states/show.
// Independent of map_leaflet_controller.ts and leaflet_markers_controller.ts — see the "Other
// mapping controllers" note in docs/MAP_CONTROLLERS.md before adding a fourth mapping integration.
export default class extends Controller {

  static targets = ['mapdiv', 'infodiv']

  initialize() {
    // google is resolved dynamically from the global window object
  }

  connect() {
    if (this.hasMapdivTarget) {
      if (typeof (window.google) !== "undefined") {
        this.initMap()
      } else {
        this.onMapsLoaded = () => {
          this.initMap()
        }
        window.addEventListener("google-maps-loaded", this.onMapsLoaded, { once: true })
      }
    }
  }

  disconnect() {
    if (this.onMapsLoaded) {
      window.removeEventListener("google-maps-loaded", this.onMapsLoaded)
    }
  }

  initMap() {
    let uluru = {lat: -23.55, lng: -46.63}
    if (typeof (this.map) == "undefined") {
      this.map = new google.maps.Map(this.mapdivTarget, {
        zoom: 4,
        center: uluru
      })
      this.bounds = new google.maps.LatLngBounds()

      let url = this.data.get('url')
      if (url) { this.loadbids() } 
      let address = this.data.get('addr')
      let id = this.data.get('id')
      if (address) { 
        this.loadaddresses()
      }   
    }
  }

  center(event) {
    event.preventDefault()
    event.stopPropagation()
    let latitude = this.data.get('lat')
    if (latitude) {
      var center = {lat: parseFloat(this.data.get('lat')), lng: parseFloat(this.data.get('lng'))}
      this.map.setCenter(center)
      this.map.setZoom(14)
    }
  }

  toggleHeatmap(event) {
    event.preventDefault()
    event.stopPropagation()
    this.heatmap.setMap(this.heatmap.getMap() ? null : this.map)
    if (this.heatmap.getMap()) {
      this.map.fitBounds(this.bounds)
      this.map.setMapTypeId("satellite")
      //this.map.panToBounds(this.bounds)
    }
  }

  changeGradient(event) {
    event.preventDefault()
    event.stopPropagation()
    var gradient = [
          'rgba(0, 255, 255, 0)',
          'rgba(0, 255, 255, 1)',
          'rgba(0, 191, 255, 1)',
          'rgba(0, 127, 255, 1)',
          'rgba(0, 63, 255, 1)',
          'rgba(0, 0, 255, 1)',
          'rgba(0, 0, 223, 1)',
          'rgba(0, 0, 191, 1)',
          'rgba(0, 0, 159, 1)',
          'rgba(0, 0, 127, 1)',
          'rgba(63, 0, 91, 1)',
          'rgba(127, 0, 63, 1)',
          'rgba(191, 0, 31, 1)',
          'rgba(255, 0, 0, 1)'
    ]
    this.heatmap.set("gradient", this.heatmap.get("gradient") ? null : gradient)
  }

  loadbids() {
    fetch(this.data.get('url'))
      .then(response => response.json())
      .then(json => {
        this.populateHMap(json)
      })
  }

  revealMarkers(event) {
    event.preventDefault()
    event.stopPropagation()
    var url = this.data.get('url')
    if (this.data.has("stateflag")) { url = this.data.get('state') }
    if (this.heatmap.getMap()) { this.heatmap.setMap(null) }
    fetch(url)
      .then(response => response.json())
      .then(json => {
        this.addbidMarkers2(json)
      })
  }

  stateHM(event) {
    event.preventDefault()
    event.stopPropagation()
    let state = this.data.get('state')
    if (state) {
      this.infodivTarget.innerText = 'Updating Heatmap...'
      fetch(this.data.get('state'))
        .then(response => response.json())
        .then(json => {
          if (this.heatmap.getMap()) { this.heatmap.setMap(null) }
          this.populateHMap(json)
          this.map.fitBounds(this.bounds)
          this.infodivTarget.innerText = ''
          this.data.set("stateflag", 1)
        })
    }
  }

  loadaddresses() {
    fetch(this.data.get('addr'))
      .then(response => response.json())
      .then(json => {
        this.addbidMarkers(json)
      })
  }

  showinfo(event) {
    event.preventDefault()
    event.stopPropagation()
    //var content = '<strong> Funcionou! </strong>'
    //this.infodivTarget.insertAdjacentHTML('beforebegin', content)
  }

  addMarker() {
    let pos = {lat: parseFloat(this.data.get('lat')), lng: parseFloat(this.data.get('lng'))}
    this.map.setZoom(14)
    this.map.panTo(pos)
  }

  addbidMarkers(json_array) {
    const infocard = this.infodivTarget
    let i = 0
    let prev_infowindow = null
    
    json_array.forEach(v => {
      if (v.latitude) {

        var icon_url = "http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=B|1E90FF|FFFFFF"
        var contentString = '<span>End: '+v.localidade+'</span><br/><span><a data-controller="mapinfo" data-action="click->mapinfo#show" href="#" id='+v.id+'> Show Bid(s) </a></span>'


        if (v.circuits >0) { 
          icon_url = "http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=C|0000FF|FFFFFF"
          contentString = '<span>End: '+v.localidade+'</span><br/><span><a data-controller="mapinfo" data-action="click->mapinfo#show" href="#" id='+v.id+'> Show Bid(s) </a></span><br/><span><a data-controller="mapinfo" data-action="click->mapinfo#showorders" href="#" id='+v.id+'> Show Order(s) </a></span>'
        }

        var pos = {lat: v.latitude, lng: v.longitude}
        var marker = new google.maps.Marker({
          position: pos,
          map: this.map,
          title: v.localidade,
          icon: icon_url
        })

        this.bounds.extend(pos)

        var infowindow = new google.maps.InfoWindow({
          content: contentString
        })

        marker.addListener('click', function() {
              this.map.panTo(pos)

              if( prev_infowindow ) {
                prev_infowindow.close()
                infocard.innerHTML = ""
              }

              infowindow.open(this.map, marker)
              prev_infowindow = infowindow
          })

        i = i+1
      }
    })

    if (i>0) {
      this.map.fitBounds(this.bounds)
      //this.map.panToBounds(this.bounds)
    }

    let latitude = this.data.get('lat')
    if (latitude) {
      var addr_pos = {lat: parseFloat(this.data.get('lat')), lng: parseFloat(this.data.get('lng'))}
      var marker = new google.maps.Marker({
        position: addr_pos,
        animation: google.maps.Animation.DROP,
        map: this.map
      }) 
      //this.bounds.extend(addr_pos)
      this.map.setCenter(addr_pos)
      this.map.setZoom(14)
      //this.map.fitBounds(bounds)
      //this.map.panToBounds(bounds)
    }

  }

  addbidMarkers2(json_array) {
    const infocard = this.infodivTarget
    let prev_infowindow = null
    
    json_array.forEach(v => {
      if (v.latitude) {

        var icon_url = "http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=B|1E90FF|FFFFFF"
        var contentString = '<span>End: '+v.localidade+'</span><br/><span><a data-controller="mapinfo" data-action="click->mapinfo#show" href="#" id='+v.id+'> Show Bid(s) </a></span>'

        if (v.circuits >0) { 
          icon_url = "http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=C|0000FF|FFFFFF"
          contentString = '<span>End: '+v.localidade+'</span><br/><span><a data-controller="mapinfo" data-action="click->mapinfo#show" href="#" id='+v.id+'> Show Bid(s) </a></span><br/><span><a data-controller="mapinfo" data-action="click->mapinfo#showorders" href="#" id='+v.id+'> Show Order(s) </a></span>'
        }

        var pos = {lat: v.latitude, lng: v.longitude}
        var marker = new google.maps.Marker({
          position: pos,
          map: this.map,
          title: v.localidade,
          icon: icon_url
        })

        //var contentString = 'End: <a data-controller="mapinfo" data-action="click->mapinfo#show" href="#" id='+v.id+'>'+v.localidade+'</a>'
        //var contentString = 'End: <a data-controller="mapbids" data-action="click->mapbids#showinfo" href="#" id='+v.id+'>'+v.street+'</a>'

        var infowindow = new google.maps.InfoWindow({
          content: contentString
        })

        marker.addListener('click', function() {
              this.map.panTo(pos)

              if( prev_infowindow ) {
                prev_infowindow.close()
                infocard.innerHTML = ""
              }

              infowindow.open(this.map, marker)
              prev_infowindow = infowindow
          })

      }
    })

  }


  populateHMap(json_array) {
    let prev_infowindow = null
    const infocard = this.infodivTarget
    let heat_locations = []
    let i = 0


    json_array.forEach(v => {
      if (v.latitude) {
        let pos = {lat: v.latitude, lng: v.longitude}

        var mpoint = new google.maps.LatLng(v.latitude,v.longitude)


        if (v.circuits >0) { 

          var icon_url = "http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=B|1E90FF|FFFFFF"

          if (v.circuits >0) { 
            icon_url = "http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=C|0000FF|FFFFFF"
            var contentString = '<span>End: '+v.localidade+'</span><br/><span><a data-controller="mapinfo" data-action="click->mapinfo#show" href="#" id='+v.id+'> Show Bid(s) </a></span><br/><span><a data-controller="mapinfo" data-action="click->mapinfo#showorders" href="#" id='+v.id+'> Show Order(s) </a></span>' 
          }

          var marker = new google.maps.Marker({
            position: pos,
            map: this.map,
            title: v.localidade,
            icon: icon_url
          })

          this.bounds.extend(pos)

          var infowindow = new google.maps.InfoWindow({
            content: contentString
          })

          marker.addListener('click', function() {
                this.map.panTo(pos)

                if( prev_infowindow ) {
                  prev_infowindow.close()
                  infocard.innerHTML = ""
                }

                infowindow.open(this.map, marker)
                prev_infowindow = infowindow
            })

        }
 
        this.bounds.extend(pos)

        heat_locations.push(mpoint)
        i = i+1
      }
    })

    this.heatmap = new google.maps.visualization.HeatmapLayer({
          data: heat_locations
    })

    var gradient = [
          'rgba(0, 255, 255, 0)',
          'rgba(0, 255, 255, 1)',
          'rgba(0, 191, 255, 1)',
          'rgba(0, 127, 255, 1)',
          'rgba(0, 63, 255, 1)',
          'rgba(0, 0, 255, 1)',
          'rgba(0, 0, 223, 1)',
          'rgba(0, 0, 191, 1)',
          'rgba(0, 0, 159, 1)',
          'rgba(0, 0, 127, 1)',
          'rgba(63, 0, 91, 1)',
          'rgba(127, 0, 63, 1)',
          'rgba(191, 0, 31, 1)',
          'rgba(255, 0, 0, 1)'
    ]
    this.heatmap.set("gradient", this.heatmap.get("gradient") ? null : gradient)

    //heatmap.set('gradient', heatmap.get('gradient') ? null : gradient)
    this.heatmap.setMap(this.map)
  }
}